import PropTypes from 'prop-types';
import React, { Component } from 'react';
import forEach from 'lodash/forEach';
import unset from 'lodash/unset';
import size from 'lodash/size';
import values from 'lodash/values';
import keys from 'lodash/keys';
import map from 'lodash/map';
import get from 'lodash/get';

import { Button } from '@lightspeed/flame/Button';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Checkbox from '@lightspeed/cirrus-checkbox';
import { Divider } from '@lightspeed/flame/Divider';

import Table from 'cirrus/Table';
import Pager from 'pages/containers/Pager';
import SearchBar from 'pages/containers/SearchBar';
import TableSorter from 'pages/containers/TableSorter';

class TableMerge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedData: {},
    };
  }

  getTableHead() {
    const { data = [], isLoading, isSaving, entity } = this.props;
    const { checkedData } = this.state;
    const checkedDataCount = size(checkedData);
    const checkedDataValues = values(checkedData).join(', ');

    let matchedDataCount = 0;
    forEach(data, oneData => {
      if (checkedData[oneData.id]) {
        matchedDataCount += 1;
      }
    });

    let isAllChecked = false;
    if (data.length) {
      if (matchedDataCount === data.length) {
        isAllChecked = true;
      } else if (matchedDataCount >= 1) {
        isAllChecked = undefined;
      }
    }

    return {
      cells: [
        {
          key: 'checkbox',
          content: (
            <Checkbox
              checked={isAllChecked}
              onChange={e => this.handleCheckAllChange(e)}
              disabled={isSaving || isLoading}
              data-test="table-merge-bulk-checkbox"
            />
          ),
          className: 'table-listing__checkbox',
          width: '2.2rem',
        },
        {
          key: 'brand',
          content: checkedDataCount ? (
            <div className="retail-table-merge">
              <Button
                variant="secondary"
                title={checkedDataValues}
                loading={isSaving}
                disabled={isLoading}
                onClick={() => this.handleMergeClick()}
                data-test="table-merge-bulk-button"
              >
                Merge <var>{checkedDataCount}</var> Brands
              </Button>
            </div>
          ) : (
            <TableSorter {...{ sortKey: 'brand.name', entity }}>Brand</TableSorter>
          ),
        },
        {
          key: 'items',
          content: <TableSorter {...{ sortKey: 'brand.items_count', entity }}>Items</TableSorter>,
          width: '10rem',
          align: 'right',
        },
      ],
    };
  }

  getTableBody() {
    const { data = [], isSaving, isLoading } = this.props;
    const { checkedData } = this.state;
    return data.length
      ? map(data, brand => ({
          key: brand.id,
          hover: true,
          cells: [
            {
              content: (
                <Checkbox
                  disabled={isSaving || isLoading}
                  data-id={brand.id}
                  checked={!!checkedData[brand.id]}
                  onChange={e => this.handleSingleChange(e, brand)}
                  data-test="table-merge-single-checkbox"
                />
              ),
              className: 'table-listing__checkbox',
            },
            {
              content: (
                <span className="cr-bold">{get(brand, 'attributes.name', 'Invalid name')}</span>
              ),
            },
            { content: <span className="cr-gray">{get(brand, 'attributes.items_count', 0)}</span> },
          ],
        }))
      : [];
  }

  handleCheckAllChange(e) {
    const { checked } = e.target;
    const { data } = this.props;
    const { checkedData } = this.state;

    if (checked) {
      forEach(data, oneData => {
        checkedData[oneData.id] = oneData.attributes.name;
      });
    } else {
      forEach(data, oneData => {
        unset(checkedData, oneData.id);
      });
    }

    this.setState({ checkedData });
  }

  handleSingleChange(event, oneData) {
    const { checked } = event.target;
    const { checkedData } = this.state;

    if (checked) {
      checkedData[oneData.id] = oneData.attributes.name;
    } else {
      unset(checkedData, oneData.id);
    }

    this.setState({ checkedData });
  }

  handleMergeClick() {
    const { checkedData } = this.state;
    const { type, source, getData, mergeData } = this.props;
    const checkedDataCount = size(checkedData);
    const formattedType = type + (checkedDataCount > 1 ? 's' : '');

    if (
      // eslint-disable-next-line no-alert
      confirm(
        `Are you sure you want to merge ${values(checkedData).join(', ')} into ${
          source.attributes.name
        }`
      )
    ) {
      mergeData(keys(checkedData), () => {
        window.flashNotifier(
          'success',
          `<var>${checkedDataCount}</var> ${formattedType} merged.`,
          5
        );
        this.setState({ checkedData: {} }, () => {
          getData();
        });
      });
    }
  }

  render() {
    const { pagination, isLoading, dataInit } = this.props;

    return (
      <Card>
        <CardSection noSpacing>
          <div className="listing__filters cr-flex cr-width-full cr-justify-between cr-ph-3 cr-pv-2 no_print">
            <SearchBar />
            <Pager {...{ pagination }} />
          </div>
        </CardSection>
        <Divider />
        <CardSection noSpacing>
          <Table
            head={this.getTableHead()}
            body={this.getTableBody()}
            isLoading={isLoading}
            dataInit={dataInit}
            noDataMessage="No brands were found."
          />
        </CardSection>
      </Card>
    );
  }
}

TableMerge.defaultProps = {
  type: 'record',
  // eslint-disable-next-line react/default-props-match-prop-types
  pagination: {},
  isLoading: false,
  isSaving: false,
};

TableMerge.propTypes = {
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  getData: PropTypes.func.isRequired,
  mergeData: PropTypes.func.isRequired,
};

export default TableMerge;
